import { render, staticRenderFns } from "./AddBannerBySliderModal.vue?vue&type=template&id=0a9e4155&scoped=true&"
import script from "./AddBannerBySliderModal.vue?vue&type=script&lang=js&"
export * from "./AddBannerBySliderModal.vue?vue&type=script&lang=js&"
import style0 from "./AddBannerBySliderModal.vue?vue&type=style&index=0&id=0a9e4155&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9e4155",
  null
  
)

export default component.exports